// 2 steps

var added_first_product = false;

function find_parent(n, t) {
	var parent = n;

	while (parent.tagName.toLowerCase() !== t) parent = parent.parentElement;
	return parent;
}

function update_product(s, n) {
	s.querySelector('.product_img').src = n.dataset.img;

	s.querySelector('h2').textContent = n.querySelector('.variant_icon').alt;
	s.querySelector('.money').outerHTML = n.dataset.price;
	s.querySelector('input[name = "id"]').value = n.dataset.variant;
}


function select_collection(e) {
	var collection = e.currentTarget.dataset.collection;
	var section = find_parent(e.currentTarget, 'section');

	find_parent(e.currentTarget, 'ul').querySelectorAll('li').forEach( function(x) {

		if (x === e.currentTarget) x.classList.add('selected');

		else x.classList.remove('selected');

	} );

	section.querySelectorAll('.products ul').forEach( function(x) {

		if (x.dataset.collection === collection) {
			update_product( section, x.querySelector('li.selected') );

			x.classList.remove('hidden');
		}

		else x.classList.add('hidden');

	} );
}

function select_product(e) {
	var section = find_parent(e.currentTarget, 'section');

	update_product(section, e.currentTarget);

	find_parent(e.currentTarget, 'ul').querySelectorAll('li').forEach( function(x) {

		if (x === e.currentTarget) x.classList.add('selected');

		else x.classList.remove('selected');

	} );
}

function add_to_cart(e) {
	e.preventDefault();

	var data = {
		items: [ {
			id: e.target.querySelector('input[name = "id"]').value,
			quantity: 1
		} ]
	};

	post('/cart/add.js', data, function(r) {
		var response = JSON.parse(r);

		if (response.status >= 300 || response.status < 200) {
			window.alert(response.description);
			return;
		}

		var button = e.target.querySelector('button');
		var item_count = document.querySelector('[data-cart-render = "item_count"]');

		button.disabled = true;
		button.classList.add('added');
		button.textContent = 'Added!';

		item_count.textContent = parseInt(item_count.textContent) + 1;

		added_first_product = true;
	} );
}


document.querySelectorAll('.collections li').forEach( function(x) {
	x.addEventListener('click', select_collection);
} );

document.querySelectorAll('.products li').forEach( function(x) {
	x.addEventListener('click', select_product);
} );

document.querySelector('#step_1').addEventListener('submit', add_to_cart);
document.querySelector('#step_2').addEventListener( 'submit', function(e) {

	if (!added_first_product) {
		e.preventDefault();

		window.alert('Please, add a pair of sunglasses first.');
	}

} );



// 3 steps

function add_all(e) {
	var data = { items: [] };

	document.querySelectorAll('.step form').forEach( function(x) {
		var item = {
			id: x.querySelector('input[name = "id"]').value,
			quantity: 1
		};

		data.items.push(item);
	} );

	post('/cart/add.js', data, function(r) {
		var response = JSON.parse(r);

		if (response.status >= 300 || response.status < 200) {
			window.alert(response.description);
			return;
		}

		window.location = '/cart';
	} );
}


document.querySelector('#last_step button').addEventListener('click', add_all);